/**
 * @fileoverview AppConfig
 *
 */
'use strict';
// Util Import
import * as ConstUtil from './util/ConstUtil';

/**
 * 設定<br>
 *
 * <ul>
 * <li>ログ 表示設定
 * <li>ログ 保存設定
 * <li>接続先
 * </ul>
 * @name AppConfig
 */
const AppConfig = {
  // ログ
  log: {
    // コンソール表示設定
    console: {
      enable: true,
      level: ConstUtil.Common.LOG_LEVEL.debug
    },
    // ログ保存設定
    record: {
      enable: true,
      level: ConstUtil.Common.LOG_LEVEL.debug
    }
  },
  // デバッグ
  isDebug: true,
  // 接続先
  //accessPoint: 'http://172.26.9.180',
  accessPoint: 'http://localhost',
  // APIポート番号
  // apiPortNumber: ':53437',
  apiPortNumber: ':8120',
  // センタードメイン
  centerDomain: 'localhost',
  // APPポート番号
  appPortNumber: ':3200',
  // バージョン情報
  versionInformation: {
    api: '/api/2.0',
    // api: '',
    version: 'localDebug',
    revision: ''
  },
  // HTTPスキーマ
  httpScheme: 'http://'
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/js/AppConfig.jsx